export default __webpack_public_path__ + "static/media/Overview_V.2.96aa7b75.png";